var Utils = require("./Utils");

function FeatureTable() {
    var self = this;

    // We refuse to connect to servers earlier than this
    var minSupportedServerVersion = "6.1.1";

    // Restrictions on the availability of certain
    // features in this app based on the functionality
    // provided by the version of the SSLVPN backend we are connected to
    // these are injected in app_common or the platform specific
    // merges - by default there are no restrictions in place
    this.restrictions = {};

    this.isFeatureSupported = function(feature) {
        var res = self.restrictions[feature];

        if (CudaLaunch.serverConfiguration) {
            var serverVersion = CudaLaunch.serverConfiguration.version;

            if (res) {
                return Utils.isGreaterThanOrEqualToServerVersion(serverVersion, res.min) &&
                    Utils.isLessThanOrEqualToServerVersion(serverVersion, res.max);
            }
            return Utils.isGreaterThanOrEqualToServerVersion(serverVersion, minSupportedServerVersion);
        }

        return false;
    };

    this.getMinServerVersionSupported = function() {
        return minSupportedServerVersion;
    };

    this.isServerVersionSupported = function(ver) {
        return Utils.isGreaterThanOrEqualToServerVersion(ver, minSupportedServerVersion);
    };

    this.setMinSupportedServerVersion = function(ver) {
        minSupportedServerVersion = ver;
    };
}

module.exports = FeatureTable;


//////////////////
// WEBPACK FOOTER
// ./common/FeatureTable.js
// module id = 67
// module chunks = 0 3